import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { TextBox, TextBoxProps } from "../../core/components/textBox";
import { FieldInstance } from "../../core/components/field";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { FullHeightContainer } from "../../core/components/FullHeighContainer";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { Helper } from "../../core/util/helper";
import { ComponentHelper } from "../../core/util/componentHelper";
import { DialogHelper } from "../../core/util/dialogHelper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { ContextGeneralSettingsApp } from "../generalSettings";
import React from "react";
export default class EditSuccursales extends React.Component<EditSuccursalesProps, EditSuccursalesState> {
    private _translations: string[] = null;
    private _options: any = null;
    private _factory = ComponentHelper.createFactory();
    private _fullLoaded: boolean;
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    if (this._checkData()) {
                        this._save();
                    } else {
                        DialogHelper.alert(this._translations["Standard.PflichtfeldAllgemein"]);
                        return false;
                    }
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false });
        },
        width: 500
    };

    constructor(props) {
        super(props);
        this._fullLoaded = false;
        this.state = { gridData: [], deleteButtonEnabled: false,  dialogOpen: false, currentItem: null };
    }

    private _checkData = () => {
        return !Helper.isNullOrEmpty(this.state.currentItem.Comment) && !Helper.isNullOrEmpty(this.state.currentItem.Ressstand);
    }

    private _getGridData = () => {
        let url = "ResourceSettings/GetSuccursales";
        HTTPService.get<JsonResultClass<Succursales[]>>(url)
            .then(result => {
                if (result.Code == 0) {
                    this.setState({ gridData: result.Data });
                }
            });
    }

    private _save = () => {
        let url = "ResourceSettings/SaveSuccursales";
        HTTPService.post<JsonResultClass>(url, { model: this.state.currentItem}).then(result => {
            if (result.Code == 0) {
                this._getGridData();
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        });
    }

    private _createDialog = () => {
        if (this.state.dialogOpen) {                             
            return (
                <div>
                    <Dialog {...this._dialogProps} open={this.state.dialogOpen} >
                        <FullHeightContainer>
                            {this._createTextBox("key")}
                            {this._createTextBox("commit")}
                        </FullHeightContainer>
                    </Dialog>
                </div>
            );
        } else {
            return (<></>);
        }
    }

    private _createTextBox = (type: "key"|"commit") => {
        let props: TextBoxProps = this._factory.getDefaultTextBoxProps();
        let label = "";
        if (type === "key") {
            label = this._translations["Standard.Key"] + "*";        
            props.value = Helper.getValueOrDefault(this.state.currentItem.Ressstand, "");
            props.field.maxLength = 2;
            props.disabled = !this.state.currentItem.IsNew;
            props.onChange = (field: { model: string }, value: any) => {
                let item = this.state.currentItem;
                item.Ressstand = value;
                this.setState({ currentItem: item });
            }
        } else {
            label = this._translations["Field.Ressource.ressstand"];        
            props.value = Helper.getValueOrDefault(this.state.currentItem.Comment, "");
            props.field.maxLength = 20;
            props.onChange = (field: { model: string }, value: any) => {
                let item = this.state.currentItem;
                item.Comment = value;
                this.setState({ currentItem: item });
            }
        }
        return (
            <FieldInstance label={label} noHover={true}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    private _delete = (dataItem: Succursales) => {
        DialogHelper.confirm(this.props.context.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                let url = "ResourceSettings/DeleteSuccursales";
                HTTPService.post<JsonResultClass>(url, { model: dataItem }).then(result => {
                    if (result.Code == 0) {
                        this._getGridData();
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
            }
        });
    }

    private _openDialog = (dataItem: Succursales = null) => {
        if (!Helper.hasValue(dataItem)) {
            dataItem = {
                Comment: "",
                IsDeletable: true,
                IsNew: true,
                Ressstand: ""
            };
        }
        this.setState({ dialogOpen: true, currentItem: dataItem })
    }

    private _createGrid = () => {

        if (this._fullLoaded) {
            const standardButtons: Array<ToolBarStandardButton> = [];
            standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.state.deleteButtonEnabled });
            let grid = (
                <Grid data={this.state.gridData} options={this._options} id="generalSettings_SuccursalesGrid" onSelectionChanged={this._handleSelectedChange}
                    standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton} selectFilter={this.state.currentItem == null ? null : this.state.currentItem.Comment} />
            );
            return (
                <div style={{ height: "300px" }}>
                    {grid}
                </div>
            )
        } else {
            return (<></>);
        }
    }

    private _handleSelectedChange = (dataItem: Succursales) => {
        if (Helper.hasValue(dataItem))
            this.setState({ deleteButtonEnabled: dataItem.IsDeletable });
        else
            this.setState({ deleteButtonEnabled: false });
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: Succursales) => {
        switch (type) {
            case (ToolBarStandardButtonType.EDIT):
                this._openDialog(dataItem)
                break;
            case (ToolBarStandardButtonType.NEW):
                this._openDialog()
                break;
            case (ToolBarStandardButtonType.DELETE):
                this._delete(dataItem);
                break;
        }
    }

    componentDidMount() {
        this._translations = this.props.context.translations;
        this._options = this.props.context.succursalesGridOptions;
        this._fullLoaded = true;
        this._getGridData();
    }

    render() {
        const grid = this._createGrid();
        const dialog = this._createDialog();
        return (
            <>
                {grid}
                {dialog}
            </>);
    }
};


interface EditSuccursalesProps {
    entity: any;
    context: ContextGeneralSettingsApp;
}

interface EditSuccursalesState {
    gridData: Succursales[];
    deleteButtonEnabled: boolean;
    dialogOpen: boolean;
    currentItem: Succursales;
}

interface Succursales {
    Ressstand: string;
    Comment: string;
    IsNew: boolean;
    IsDeletable: boolean;
}